import { Task } from './task'
import { Quiz } from './quiz'
import { TaskReflection } from './task-reflection'
import { QuizReflectionBlock } from './quiz-reflection-block'

export interface QuizActivityTaskInterface {
  task?: Task
  quiz?: Quiz
  /**
   * 前台用户请求接口
   *  - 返回当前用户【活动任务】完成情况
   */
  taskCompletedInfo?: TaskReflection | null
  /**
   * 前台用户请求接口
   *  - 返回当前用户答题题目块记录
   */
  quizReflectionBlock?: QuizReflectionBlock | null
  /**
   * 后台用户请求接口
   *  - 是否有用户参与测验活动
   */
  userJoinActivityTask?: boolean
  /**
   * 后台用户请求接口
   *  - 已完成任务人数
   */
  userCompletedCount?: number
  /**
   * 后台用户请求接口
   *  - 是否有用户提交测验活动答案
   */
  userSubmitActivityTask?: boolean
  /**
   * 总分
   */
  fullScore?: string
}

export class QuizActivityTask implements QuizActivityTaskInterface {
  task?: Task
  quiz?: Quiz
  /**
   * 前台用户请求接口
   *  - 返回当前用户【活动任务】完成情况
   */
  taskCompletedInfo?: TaskReflection | null
  /**
   * 前台用户请求接口
   *  - 返回当前用户答题题目块记录
   */
  quizReflectionBlock?: QuizReflectionBlock | null
  /**
   * 后台用户请求接口
   *  - 是否有用户参与测验活动
   */
  userJoinActivityTask?: boolean
  /**
   * 后台用户请求接口
   *  - 已完成任务人数
   */
  userCompletedCount?: number
  /**
   * 后台用户请求接口
   *  - 是否有用户提交测验活动答案
   */
  userSubmitActivityTask?: boolean
  /**
   * 总分
   */
  fullScore?: string

  constructor(props: QuizActivityTaskInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      task: _task,
      quiz: _quiz,
      taskCompletedInfo: _taskCompletedInfo,
      quizReflectionBlock: _quizReflectionBlock,
      userJoinActivityTask: _userJoinActivityTask,
      userCompletedCount: _userCompletedCount,
      userSubmitActivityTask: _userSubmitActivityTask,
      fullScore: _fullScore,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.task = _task ? new Task(_task) : _task
    this.quiz = _quiz ? new Quiz(_quiz) : _quiz
    this.taskCompletedInfo = _taskCompletedInfo
      ? new TaskReflection(_taskCompletedInfo)
      : _taskCompletedInfo
    this.quizReflectionBlock = _quizReflectionBlock
      ? new QuizReflectionBlock(_quizReflectionBlock)
      : _quizReflectionBlock
    this.userJoinActivityTask = _userJoinActivityTask
    this.userCompletedCount = _userCompletedCount
    this.userSubmitActivityTask = _userSubmitActivityTask
    this.fullScore = _fullScore
  }
}
